import { useState } from "react";
import { toast } from "sonner";
import { approvalEmailTest } from "../lib/api";

// Panel shown above the admin tool list. Sends a copy of the real approval email
// ("your tool is live — claim it") to any inbox so you can check where it lands.
// Mirrors the live send exactly. Sending a test does not change the real email.
export default function ApprovalEmailTest() {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);

  const send = async () => {
    const to = email.trim();
    if (!to) return toast.error("enter an email to test");
    setSending(true);
    try {
      await approvalEmailTest(to);
      toast.success(`approval email sent to ${to}`);
    } catch {
      toast.error("test send failed");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="border border-black p-4 mb-4 space-y-3" data-testid="approval-email-test">
      <div className="text-[12px] font-bold">
        test the approval email (the one sent when you approve an owner&rsquo;s tool)
      </div>
      <p className="text-[11px] text-[#666] max-w-[74ch]">
        Sends an exact copy of the real &ldquo;your tool is live &mdash; claim it&rdquo; email to any inbox so
        you can see where it lands &mdash; check the inbox <b>and the spam folder</b>.
        {" "}<b>Sending a test does not change the real email.</b>
      </p>
      <div className="flex flex-wrap gap-2 items-center">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && send()}
          placeholder="you@gmail.com"
          className="border border-black px-2 py-1 text-[13px] w-[260px] max-w-full"
          data-testid="approval-email-test-input"
        />
        <button
          onClick={send}
          disabled={sending}
          className="border border-black bg-black text-white px-3 py-1 text-[12px] disabled:opacity-50"
          data-testid="approval-email-test-send"
        >
          {sending ? "sending…" : "send me the approval email"}
        </button>
      </div>
    </div>
  );
}
